const { circle } = require("leaflet");

define([
    "jquery",
    "loglevel",
    "underscore",
    "handlebars",
    "leaflet",
    "load-google-maps-api-2",
    "../config/config",
    "../html/maps/template.hbs",
    "../nls/labels",
    'typeahead.js',
    "json-2-csv",
    "file-saver",
    "bootstrap",
    "bootstrap-table",
    '../../node_modules/bootstrap-table/dist/extensions/export/bootstrap-table-export',
    '../../node_modules/bootstrap-table/dist/bootstrap-table-locale-all',
    'select2'

], function ($, log, _, Handlebars, L, GoogleMaps, C, template, labels, Bloodhound, converter, FileSaver, bootstrap) {

    "use strict";
    var Clang = C.lang.toLowerCase();
    var map = null;

    var s = {
            EL: "#maps",
            TABLE : "#table"
        },
        error = {
            en: "Server side error",
            es: "Error del lado del servidor",
            fr: "Erreur côté serveur",
            ru: "Ошибка на стороне сервера",
            ar: "خطأ جانب الخادم",
            zh: "服务器端错误"
        },
        service_path = {
            "wiews_exsitu_crops_filter" : "?index=crops&multiSearch=false",
        },
        services_el = C.URL_elasticsearchapi,
        exsitu_search_url = C.URL_exsitusearch,
        organization_url = C.URL_organizations,        
        services_url = C.URL_saikumap,
        services_url_map = C.URL_bigMap,
        saiku_url = C.URL_saiku,
        //google_apikey = (window.location.hostname == "localhost") ? "AIzaSyBuHFI5p2EP0jdpliVr1BQgx-zprRNRjcc" : C.google_apikey ;
        google_apikey = "AIzaSyBuHFI5p2EP0jdpliVr1BQgx-zprRNRjcc";

    function Maps() {
        //console.clear();
        // silent trace
        log.setLevel("silent");
        this._importThirdPartyCss();
        this._validateConfig();
        this._initVariables();
        this._attach();
        this._bindEventListeners();
    };

    Maps.prototype._queryMap = function (year, crop) {
        console.log("QueryMap:")
        var response_data = {},
            language = (Clang == "en") ? "" : "_"+Clang,
            payload_full = {
                "queryModel": {},
                "cube": {
                                "uniqueName": "[wiews_indicators].[wiews_map_agg]",
                                "name": "wiews_map_agg",
                                "connection": "wiews_indicators",
                                "catalog": "wiews_indicators",
                                "schema": "wiews_indicators",
                                "caption": null,
                                "visible": false
                },
                    "mdx": "WITH SET [year] AS {[dims_maps_agg].["+this.currentYear+"]} SET [reg_name] AS Exists({[dims_maps_agg].[reg_name].Members}, [year]) SET [country_iso3] AS Exists({[dims_maps_agg].[country_iso3].Members}, [reg_name]) SET [country_name"+language+"] AS Exists({[dims_maps_agg].[country_name"+language+"].Members}, [country_iso3]) SET [instcode] AS Exists({[dims_maps_agg].[wiews_instcode].Members}, [country_name"+language+"])SET [organization] AS Exists({[dims_maps_agg].[organization_name].Members}, [instcode]) SET [latitude] AS Exists({[dims_maps_agg].[instcode_lat].Members}, [organization]) SET [longitude] AS Exists ({[dims_maps_agg].[instcode_long].Members}, [latitude]) SET [~ROWS] AS Hierarchize({[year],[reg_name], [country_iso3], [country_name"+language+"], [instcode], [organization], [latitude], [longitude]}) SELECT NON EMPTY {[Measures].[accessions], [Measures].[distinct_genus], [Measures].[distinct_genus_species]} ON COLUMNS, NON EMPTY [~ROWS] ON ROWS FROM [wiews_map_agg]",
                    "type": "MDX"
            },
            payload = {
                "queryModel": {},
                "cube": {
                                "uniqueName": "[wiews_indicators].[wiews_map_agg]",
                                "name": "wiews_map_agg",
                                "connection": "wiews_indicators",
                                "catalog": "wiews_indicators",
                                "schema": "wiews_indicators",
                                "caption": null,
                                "visible": false
                },
                    "mdx": "WITH SET [~FILTER] AS {[crop"+language+"].["+this.currentCrop+"]} SET [year] AS {[dims_maps_agg].["+this.currentYear+"]} SET [reg_name] AS Exists({[dims_maps_agg].[reg_name].Members}, [year]) SET [country_iso3] AS Exists({[dims_maps_agg].[country_iso3].Members}, [reg_name]) SET [country_name"+language+"] AS Exists({[dims_maps_agg].[country_name"+language+"].Members}, [country_iso3]) SET [instcode] AS Exists({[dims_maps_agg].[wiews_instcode].Members}, [country_name"+language+"])SET [organization] AS Exists({[dims_maps_agg].[organization_name].Members}, [instcode]) SET [latitude] AS Exists({[dims_maps_agg].[instcode_lat].Members}, [organization]) SET [longitude] AS Exists ({[dims_maps_agg].[instcode_long].Members}, [latitude]) SET [~ROWS] AS Hierarchize({[year],[reg_name], [country_iso3], [country_name"+language+"], [instcode], [organization], [latitude], [longitude]}) SELECT NON EMPTY {[Measures].[accessions], [Measures].[distinct_genus], [Measures].[distinct_genus_species]} ON COLUMNS, NON EMPTY [~ROWS] ON ROWS FROM [wiews_map_agg] Where [~FILTER]",
                    "type": "MDX"
            };
            var selection = $('#data_international').val();
            var field= $('#data_showed').val()
            var dataFilter = $('#data_filter').val()
            var crop = $('#search_crop').val()
        const req = {
            "lang":Clang, 
            "field": field, 
            "filters":
                {
                    "year":year, 
                    "threshold": dataFilter, 
                    "region": selection,
                    //"crop":crop
                }
            }
        if(crop){
            req.filters.crop = crop
        }
            console.log(req)
        $.ajax({
            async: false,
            dataType: 'json',
            method: 'POST',
            contentType: "text/plain; charset=utf-8",
            url:  services_url_map,
            //data: JSON.stringify((crop != undefined && crop.length <1) ? payload_full : payload),
            data: JSON.stringify(req),
            success: function(res) {
                console.log('res is :',res);
                response_data = res;
            },
            error : function(res) {
                console.log(res);
                return;
            }

        });

        return response_data;

    }

    Maps.prototype._validateConfig = function () {
        if (!C.lang) alert("Please specify a valid LANGUAGE in config/config.js");
        GoogleMaps.key = google_apikey;
        GoogleMaps.language = Clang.toLowerCase();
    };

    Maps.prototype._convert2TableData = function (input) {
        var output = [];
        var selection = $('#data_international').val();
        var year = $('#year').val().split(/[^0-9]/).join("");

        _.each(input, function(object, index) {
            //console.log(object);
            var obj = {
                "year" : object.year,
                "country" : object.country,
                "instcode" : object.wiews_instcode,
                "name": object.organization_name,
                //"type": object[2].value,
                "accessions" : Number(object.accessions),
                "genus" : Number(object.genus),
                "species" : Number(object.species),
                "coordinates": [ Number(object.coordinates[1]), Number(object.coordinates[0]) ]
            };
            //console.log(selection.includes(object[2].value))
            //if (index>0 && selection.includes(object[2].value)) 
                output.push(obj);
        });
        //console.log(output);
        return output;
    };

    Maps.prototype._convert2GEOJson = function (input, selection) {
        var geoJSON = {
                "type": "FeatureCollection",
                "features" : []
            },
            output = [];

        _.each(input, function (object, index) { 
            
            if (!isNaN(object[6].value) && !isNaN(object[7].value)) { 

                var obj = {
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [ Number(object[7].value), Number(object[6].value) ]
                    },
                    "properties": {
                        "year" : object[0].value,
                        "country" : object[3].value,
                        "instcode" : object[4].value,
                        "name": object[5].value,
                        "type": object[2].value,
                        "accessions" : Number(object[8].value.split(',').join("")),
                        "genus" : Number(object[9].value.split(',').join("")),
                        "species" : Number(object[10].value.split(',').join("")),
                        "coordinates": [ Number(object[7].value), Number(object[6].value) ]
                    },
                    "id" : object[4].value
                };
    
                if (index > 0 && object[6].value.length > 0 && selection.includes(object[2].value)) {
                    //  console.log(obj);
                    output.push(obj);
                }
    

            } else { 
                //  if (isNaN(object[6].value)) console.log((Number(object[6].value), object[6].value))
                //  if (isNaN(object[7].value)) console.log((Number(object[7].value), object[7].value))    
            }

        });        

        geoJSON.features = output;
        return geoJSON;

    };

    Maps.prototype._convert2GEOJsonBQ = function (input, selection) {
        var geoJSON = {
                "type": "FeatureCollection",
                "features" : []
            },
            output = [];

        _.each(input, function (object, index) { 
            
                var obj = {
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [ Number(object.coordinates[1]), Number(object.coordinates[0]) ]
                    },
                    "properties": {
                        "year" : object.year,
                        "country" : object.country,
                        "instcode" : object.wiews_instcode,
                        "name": object.organization_name,
                        "type": object.type,
                        "accessions" : Number(object.accessions),
                        "genus" : Number(object.genus),
                        "species" : Number(object.species),
                        "coordinates": [ Number(object.coordinates[1]), Number(object.coordinates[0]) ]
                    },
                    //"id" : object[4].value
                    "id" : object.wiews_instcode
                };
    
                //if (index > 0 && object[6].value.length > 0 && selection.includes(object[2].value)) {
                    //  console.log(obj);
                    output.push(obj);
                //}
    

           

        });        
        console.log(output)
        geoJSON.features = output;
        return geoJSON;

    };

    Maps.prototype._getData = function (year, crop) {

        // console.log("in getdata ", year, crop);

        //if (this.currentYear == year && this.currentCrop == crop) return this.data;

        var data,
            //cropreplace = (crop == "") ? crop : crop+"_" ,
            url = services_url.replace("{{YEAR}}", year).replace("{{CROP}}", crop);

        // console.log("url is ", url);

        $.ajax({
            async: false,
            dataType: 'json',
            method: 'GET',
            contentType: "text/plain; charset=utf-8",
            url:  url,
            success: function(res) {
                //console.log('res is ',res);
                data = res;
            },
            error : function(res) {
                alert(error[Clang]);
                console.log(res);
            }
        });

        this.currentYear = year;
        this.currentCrop = crop;
        this.data = data;

        return data;

    };

    Maps.prototype._processMap = function (data_toshow) {
        var self = this;
        //var data = this._getData($('#year').val(), $('#search_crop').val());
        map && map.off()
        map && map.remove()
        map = L.map('map').setView([15,25], 2);        
        L.tileLayer('https://pro-ags1.dfs.un.org/arcgis/rest/services/basemaps/clearmap_webtopo_nolabel_cvw/MapServer/tile/{z}/{y}/{x}', {    
            attribution: '<a href="https://geoservices.un.org/Html5Viewer/index.html?viewer=clearmap" target="_blank">UN Geospatial Clearmap</a>',
            minZoom: 1,
            maxZoom: 7,
            zIndex: 1,
            opacity: 1
        }).addTo(map);
        
        setTimeout(function(){
            
            var data = self._queryMap($('#year').val(), $('#search_crop').val());
            var selection = $('#data_international').val();

            if (data == undefined) {
                // console.log(data);
                alert(labels[Clang]['maps_error']);
                return;
            }
            
            var geodata = self._convert2GEOJsonBQ(data.data, selection),
                original_radius = [],
                multiplier = 4,
                group = [];
        
            console.log(geodata)
            L.geoJson(geodata,{
                onEachFeature: function (feature, layer) {
                    //console.log("tintoria", getRadius(feature.properties[data_toshow]), getCircle(feature.properties[data_toshow], feature.properties.type))
                    var circle = L.circle([feature.properties.coordinates[1], feature.properties.coordinates[0]], getRadius(feature.properties[data_toshow], multiplier), getCircle(feature.properties[data_toshow], feature.properties.type) );
                    original_radius.push(getRadius(feature.properties[data_toshow], multiplier))
                    circle.setRadius((getRadius(feature.properties[data_toshow], multiplier)/(map.getZoom()*multiplier))*multiplier);

                    circle.bindPopup("<span><b><a target='_blank' href='"+organization_url+self.lang.toLowerCase()+"/?instcode="+feature.properties['instcode']+"'>"+feature.properties['instcode']+"</a></b>" +
                        " - <i>"+feature.properties['name']+"</i> </span><br>" +
                        "<br><span> <b>"+labels[Clang]['maps_accessions']+":</b> "+feature.properties['accessions'].toLocaleString()+"</span><br>" +
                        "<span> <b>"+labels[Clang]['maps_genera']+":</b> "+feature.properties['genus'].toLocaleString()+"</span><br>" +
                        "<span> <b>"+labels[Clang]['maps_species']+":</b> "+feature.properties['species'].toLocaleString()+"</span><br>" +
                        "<br><b><a href='"+exsitu_search_url+self.lang.toLowerCase()+"/?instcode="+feature.properties['instcode']+"'>"+labels[Clang]['maps_toexitu']+"</a></b>");  
                    
                    group.push(circle);
                }
            });

            var grouping = L.layerGroup(group).addTo(map);
            
            map.on("load", function() { 
                console.log('really? now?')
                self._toggleLoading(); 
            });

            //map.on("zoomstart", function (type, target) { console.log("ZOOMSTART", type, target, map.getZoom()); });
            map.on("zoomend", function (type) { 
                $.each(group,function(index, item){
                    //console.log('old',item.getRadius(),'new', (item.getRadius()/map.getZoom())*2)
                    item.setRadius((original_radius[index]/(map.getZoom()*multiplier))*multiplier);
                    //item.setRadius(getRadius(feature.properties[data_toshow],map.getZoom()))
                })
            });

            function getRadius(size, zoom) {
                var value = $('#data_filter').val(),
                    thereIsACrop = ($('#search_crop').val().length > 1) ? 2 : 1,                
                    kind = $('#data_showed').val(),
                    mag = Math.pow(Number(size), 1/4),
                    divisor = (kind === "accessions") ? 3 : 8,
                    multi = thereIsACrop; //self.zoomlevel /2;

                var ritorno = (size > value) ? ((mag/4)*divisor)*multi : 0;

                return ritorno*(zoom*14)*1000;
            }

            function getCircle(size, color) {            
                var value = $('#data_filter').val(),
                    thereIsACrop = ($('#search_crop').val().length > 1) ? 2 : 1,
                    true_color = 'red',
                    kind = $('#data_showed').val(),
                    mag = Math.pow(Number(size), 1/4),
                    divisor = (kind === "accessions") ? 3 : 8,
                    multi = thereIsACrop; //self.zoomlevel /2;

                //console.log(thereIsACrop)

                //if (color == "OTHER") {}
                if (color == "INT") true_color = 'blue';
                if (color == "REG") true_color = 'green';

                return {                
                    fillColor: true_color,
                    fillOpacity: .2,
                    radius:  getRadius(size),
                    color: 'white',
                    weight: .5
                };
            }

            /*
            GoogleMaps().then(function (googleMaps) {
                //console.log(googleMaps);
                var map = new googleMaps.Map(document.getElementById('map'), {
                    zoom: 2,
                    mapTypeId: google.maps.MapTypeId.SATELLITE,
                    labels: true,
                    center: new google.maps.LatLng(15,25),
                    //disableDefaultUI: true,
                    mapTypeControl: false,
                    gestureHandling: 'cooperative',
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    },
                });

                map.data.setStyle(function(feature) {
                    var size = feature.getProperty(data_toshow);
                    var color = feature.getProperty('type');                
                    return {
                        icon: getCircle(size, color),
                        title: feature.getProperty('name')
                    };
                });

                var infowindow = new googleMaps.InfoWindow({});

                map.addListener('zoom_changed', function(event) {
                    self.zoomlevel = map.getZoom();

                    map.data.setStyle(function(feature) {
                        var size = feature.getProperty(data_toshow);
                        var color = feature.getProperty('type');
                        return {
                            icon: getCircle(size, color),
                            title: feature.getProperty('name')
                        };
                    });
                });

                map.data.addGeoJson(geodata);


                map.data.addListener('click', function(event) {
                    //console.log(event.feature.getProperty('coordinates'));
                    infowindow.close();
                    //var opening = new googleMaps.LatLng(event.feature.b.b.lat(), event.feature.b.b.lng());
                    var opening = new googleMaps.LatLng(event.feature.getProperty('coordinates')[1],event.feature.getProperty('coordinates')[0]);
                    //var opening = new googleMaps.LatLng();
                    infowindow.setPosition(opening);
                    infowindow.setContent(
                        "<span><b><a target='_blank' href='"+organization_url+self.lang.toLowerCase()+"/?instcode="+event.feature.getProperty('instcode')+"'>"+event.feature.getProperty('instcode')+"</a></b>" +
                        " - <i>"+event.feature.getProperty('name')+"</i> </span><br>" +
                        "<br><span> <b>"+labels[Clang]['maps_accessions']+":</b> "+event.feature.getProperty('accessions').toLocaleString()+"</span><br>" +
                        "<span> <b>"+labels[Clang]['maps_genera']+":</b> "+event.feature.getProperty('genus').toLocaleString()+"</span><br>" +
                        "<span> <b>"+labels[Clang]['maps_species']+":</b> "+event.feature.getProperty('species').toLocaleString()+"</span><br>" +
                        "<br><b><a href='"+exsitu_search_url+self.lang.toLowerCase()+"/?instcode="+event.feature.getProperty('instcode')+"'>"+labels[Clang]['maps_toexitu']+"</a></b>"
                    );
                    infowindow.open(map);

                });

                self._toggleLoading();

                function getCircle(size, color) {
                    var value = $('#data_filter').val(),
                        thereIsACrop = ($('#search_crop').val().length > 1) ? 2 : 1,
                        true_color = 'red',
                        kind = $('#data_showed').val(),
                        mag = Math.pow(Number(size), 1/4),
                        divisor = (kind === "accessions") ? 3 : 8,
                        multi = thereIsACrop; //self.zoomlevel /2;

                    //console.log(thereIsACrop)

                    //if (color == "OTHER") {}
                    if (color == "INT") true_color = 'blue';
                    if (color == "REG") true_color = 'green';

                    return {
                        path: googleMaps.SymbolPath.CIRCLE,
                        fillColor: true_color,
                        fillOpacity: .2,
                        scale:  (size > value) ? ((mag/4)*divisor)*multi : 0,
                        strokeColor: 'white',
                        strokeWeight: .5
                    };
                }



            }).catch(function (err) {
                console.error(err);
            });
            */

            var tableData = self._convert2TableData(data.data);
            self._bootstrapTable(tableData);
            self._toggleLoading(); 
        }, 500);        
    };

    Maps.prototype._bootstrapTable = function (data) {
        var self = this;
        var btLocale = {
            en : "en-US",
            es : "es-ES",
            fr : "fr-FR",
            ru : "ru-RU",
            ar : "ar-SA",
            zh : "zh-CN"
        };

        $(s.TABLE).bootstrapTable('destroy');
        $(s.TABLE).bootstrapTable({
            data : data,
            locale: btLocale[C.lang.toLowerCase()],
            pagination: true,
            pageSize: 25,
            pageList: [25],
            search: true,
            formatSearch: function() {
                return labels[Clang]['organizations_search_filter']
            },
            sortable: true,
            paginationVAlign: "top"
        });
        $('#table').on('click-row.bs.table', function(row, $element, field){
            window.location.href = organization_url +self.lang.toLowerCase()+"/?instcode="+$element['instcode']+"#details";
        });
    };

    Maps.prototype._toggleLoading = function () {
        setTimeout(function(){
            if( $("[data-page=maps]").css('opacity') == '1') {
                $('div[data-page="loaded"]').show();
                $('div[data-page="maps"]').css('opacity','0.5');
            } else {
                $('div[data-page="loaded"]').hide();
                $('div[data-page="maps"]').css('opacity','1');
            }
        }, 150);

    }

    Maps.prototype._bloodHoundPrefetchElastic = function (which, keyitem) {
        var self = this;
        var rest_service = services_el;
        return new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            identify: function(obj) { return obj.name; },
            remote: {
                url: rest_service + service_path[which],
                prepare: function (query, settings) {
                    settings.async = false;
                    settings.type = "POST";
                    settings.contentType = "text/plain; charset=utf-8";
                    settings.dataType = 'json';
                    settings.data = JSON.stringify(self._prepareElasticPayload(which,query));
                    return settings;
                },
                transform: function(response) {
                    var response_data = [];
                    //console.log('response for '+which+' is ', response);
                    if(response.aggregations != undefined)
                    if (response.aggregations.result_set.buckets.length) {
                        _.each( response.aggregations.result_set.buckets, function ( element ) {
                            response_data.push(element);
                        });
                    }
                    // Special case for DOI
                    if (response.hits.hits.length) {
                        _.each( response.hits.hits, function ( element ) {
                            var item =  {
                                key : element._source[keyitem],
                                //value : element._source[keyitem]
                            };
                            response_data.push(item);
                        });
                    }
                    //console.log(response_data)
                    return response_data;
                },
                rateLimitWait: 750

            }
        });
    };

    Maps.prototype._prepareElasticPayload = function (which, text) {
        var crop_name_lang  = "crop_name_"+Clang,
            crop_object = {},
            crop_lowercase  = crop_name_lang+".lowercase",
            crop_aggregator = crop_name_lang+".aggregator";

        crop_object[crop_lowercase] = {
            "value": "*"+text+"*",
            "rewrite": "scoring_boolean"
        };

        var crop_payload = {
            "query": {
                "wildcard": crop_object
            },
            "size":"0",
            "aggs": {
                "result_set": {
                    "terms": {
                        "field": crop_aggregator,
                        "order": {"max_score": "asc"}
                    },
                    "aggs": {
                        "max_score": {
                            "max": {"script": "_score"}
                        }
                    }
                }
            }
        };
        

        if (which == "wiews_exsitu_crops_filter") return crop_payload;

    };

    Maps.prototype._attach = function () {

        $(s.EL).html(template(labels[Clang]));

        $('[data-role=details]').hide();
        $('#tabled').hide();


        //var data = this._getData($('#year').val(), $('#search_crop').val());
        var data = {};

        var tableData = this._convert2TableData(data.cellset);
        this._bootstrapTable(tableData);

        this._processMap($('#data_showed').val());

        this.tabledata = this._convert2CSV(tableData);

        $('#year').select2({ width: '100%',  theme: "bootstrap" });
        $('#data_showed').select2({ width: '100%' , theme: "bootstrap" });
        $('#data_international').select2({ width: '100%' , theme: "bootstrap" });
        $('#crop_filter').select2({ width: '100%' , theme: "bootstrap" });

        var prefetchCrops = this._bloodHoundPrefetchElastic('wiews_exsitu_crops_filter');

        $('#search_crop').typeahead(this.tya_options,
            {
                name: 'search_crop',
                display: 'key',
                limit: 100,
                source: prefetchCrops,
                templates: {
                    suggestion: Handlebars.compile('<div>{{key}}</div>'),
                    empty: Handlebars.compile('<div class="tya_notfound">'+labels[Clang]['organizations_search_not_found']+'</div>'),
                }
            }
        );

        this._toggleLoading();
        this._updateFilter();

    };

    Maps.prototype._updateFilter = function (selection) {

        $('#data_filter').empty();
        $('#data_filter').append('<option value="0">'+labels[Clang]['maps_selection_all']+'</option>');

        if (selection == "genus" || selection == "species") {
            $('#data_filter').append('<option value="10">'+labels[Clang]['maps_above_10']+'</option>');
            $('#data_filter').append('<option value="100">'+labels[Clang]['maps_above_100']+'</option>');
        } else {
            $('#data_filter').append('<option value="5000">'+labels[Clang]['maps_above_5000']+'</option>');
            $('#data_filter').append('<option value="10000">'+labels[Clang]['maps_above_10000']+'</option>');
            $('#data_filter').append('<option value="50000">'+labels[Clang]['maps_above_50000']+'</option>');
        }
        $('#data_filter').select2({ width: '100%',  theme: "bootstrap" });


    }

    Maps.prototype._convert2CSV = function (data) {

        var entities = {
            "OTHER" : labels[Clang]['maps_select_national'],
            "INT" : labels[Clang]['maps_select_international'],
            "REG" : labels[Clang]['maps_select_regional']
        };

        _.each(data, function(object) {
            object['name'] = "\""+object['name']+"\"";
            object['type'] = entities[object['type']];
        });
        return data;

    };

    Maps.prototype._initVariables = function () {

        this.$el = $(s.EL);
        this.lang = Clang;
        this.environment = C.ENVIRONMENT;
        this.cache = C.cache;
        this.zoomlevel = 2;
        this.currentYear = $('#year').val() || 2022 ;
        this.currentCrop = $('#search_crop').val() || "";

    };

    Maps.prototype._bindEventListeners = function () {

        var self = this;

        $('#search_crop').on('typeahead:selected', function(evt, item) {
            self.currentCrop = item.key;
            self._toggleLoading();
            setTimeout(function(){ self._processMap($('#data_showed').val()); }, 200);
        });

        $("#clear_search_crop").on('click', function(){
            $('#search_crop').val('');
            self.currentCrop = "";
        });

        $('#search_crop').on("typeahead:closed",function() { 
            console.log("hey hey hey");
        });

        $('#search_crop').on('typeahead:idle', function(evt, item){
            if ($('#search_crop').val() == "") {
                $('.typeahead').typeahead('val', '');
                self.currentCrop = "";
                self._toggleLoading();
                setTimeout(function(){ self._processMap($('#data_showed').val()); }, 200);
            }
        })

        $('#showasmap').on('click', function () {
            $('#maped').toggle();
            $('#tabled').toggle();
            $('[data-role = filters]').toggle();

            if ($('#map').is(":visible")) {                
                self._toggleLoading();
                self._processMap($('#data_showed').val());
                $('#btn_text').html(labels[Clang]['maps_table_label'])
            } else {
                $('#btn_text').html(labels[Clang]['maps_map_label'])
            }
            if (map && map.remove) {
                    map.off();
                    map.remove();
                }

        });

        $('#year').on('change', function () {
            self.currentYear =  $('#year').val();
            self._toggleLoading();            
            setTimeout(function(){ self._processMap($('#data_showed').val()); }, 200);
        });

        $('#crop_filter').on('change', function () {
            self._toggleLoading();
            setTimeout(function(){ self._processMap($('#data_showed').val()); }, 200);
        });

        $('#data_international').on('change', function () {
            self._toggleLoading();
            setTimeout(function(){ self._processMap($('#data_showed').val()); }, 200);
        });

        $('#data_showed').on('change', function () {
            self._updateFilter($('#data_showed').val());
            self._toggleLoading();
            setTimeout(function(){ self._processMap($('#data_showed').val()); }, 200);
        });

        $('#data_filter').on('change', function () {
            self._toggleLoading();
            setTimeout(function(){ self._processMap($('#data_showed').val()); }, 200);
        });

        $('[data-role=exsitu_exportbutton]').on('click', function() {
            var json2csvCallback = function (err, csv) {
                if (err) throw err;
                var blob = new Blob([csv], {type: "text/csv;charset=utf-8"});
                FileSaver.saveAs(blob, "exsitu.csv");
            };
            converter.json2csv(self.tabledata, json2csvCallback);
        });

    };

    Maps.prototype._importThirdPartyCss = function () {


        //SANDBOXED BOOTSTRAP
        require("../css/sandboxed-bootstrap.css");
        //dropdown selector
        require("../../node_modules/select2/dist/css/select2.css");
        require("../../node_modules/select2-bootstrap-theme/dist/select2-bootstrap.css")

        require("../../node_modules/fenix-ui-table-creator/dist/fenix-ui-table-creator.min.css");

        //tree selector
        //require("../../node_modules/jstree/dist/themes/default/style.min.css");
        // fenix-ui-filter
        require("../../node_modules/fenix-ui-filter/dist/fenix-ui-filter.min.css");

        // bootstrap-table
        require("../../node_modules/bootstrap-table/dist/bootstrap-table.min.css");

        // leaflet
        require("../../node_modules/leaflet/dist/leaflet.css");

        //Wiews CSS
        if (window.location.hostname == "localhost") require("../css/wiews.css");

    };

    return new Maps();

});